import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36470832"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-index-row"
};
const _hoisted_2 = ["textContent"];
const _hoisted_3 = ["innerHTML"];
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
        class: "label",
        textContent: _toDisplayString(__props.label)
      }, null, 8, _hoisted_2), _createElementVNode("div", {
        class: "content",
        innerHTML: __props.content
      }, null, 8, _hoisted_3)]);
    };
  }
};